
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect, useState } from 'react';
import useTranslation from "next-translate/useTranslation";
import Navigation from "../components/layout/Navigation";
import Footer from "../components/layout/Footer";
import MainLayout from "../components/layout/MainLayout";
import Services from "../components/services";
import Loader from "../components/Loader";
const Privacy = () => {
    const { t } = useTranslation();
    const seo = t('common:seo', {}, { returnObjects: true });
    const data = t('services:cookies', {}, { returnObjects: true });
    const [isLoading, setIsLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);
    const pageSchema = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": seo.cookies_page.title,
        "description": seo.cookies_page.description,
        "url": `${process.env.NEXT_PUBLIC_SITE_URL}/cookies-policy`,
        "publisher": {
            "@type": "Organization",
            "name": "HFDX"
        }
    };
    useEffect(() => {
        let appLoading = new Promise((resolve) => {
            setTimeout(resolve, 500, true);
        });
        Promise.all([appLoading]).then(() => {
            setIsLoading(false);
            setLoaded(true);
        });
    }, []);
    return (<MainLayout loaded={loaded} title={seo.cookies_page.title} description={seo.cookies_page.description} alternate={'cookies-policy'} canonical={'/cookies-policy'} page={'services'} schemaData={pageSchema}>
            <Navigation />
            <main className='main' style={{ overflowX: 'hidden' }}>
                <Services data={data}/>
            </main>
            <Footer t={t}/>
            <Loader isLoading={isLoading} loaded={loaded}/>
        </MainLayout>);
};
export default Privacy;

    async function __Next_Translate__getStaticProps__1a17ab3f1d0__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cookies-policy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a17ab3f1d0__ as getStaticProps }
  